import { buildEndpoint } from '../endpoints';
import { apifetch } from '../robotapi';

export const getModelPortfolioUrl = (id: string) => buildEndpoint(['modelportfolio', id, 'factsheetdata']);

export const getModelPortfolioApiCall = (id: string) =>
    apifetch<GetModelPortfolioResponse>(getModelPortfolioUrl(id), 'GET');

export const useGetModelPortfolio = () => {};

export interface BasicCharacteristics {
    startDate: string;
    managementFee: number;
    modelPortfolioManager: string;
}

export interface RiskCharacteristics {
    standarddeviation36M: number;
    sharpeRatio36M: number;
}

export interface CharacteristicsUnderlyingStocks {
    numberOfStocks: number;
    averageMarketCapitalization: number;
    dividend: number;
    rentabilityOwnAssets: number;
    rateBookValueRatio: number;
    rateProfitRatio: number;
}

export interface CharacteristicsUnderlyingBonds {
    numberOfBonds: number;
    yieldToMaturity: number;
    averageCouponRate: number;
    averageDuration: number;
    averageCreditQuality: string;
    averageWeightedDuration: number;
}

export interface HistoricalReturnData {
    historicalReturnTypeId: number;
    description: string;
    year: number;
    returnAfterCosts: number;
    returnBeforeCosts: number;
    returnBenchmark: number;
}

export interface StockSector {
    sectorId: number;
    sectorName: string;
    sectorWeight: number;
}

export interface BondSector {
    sectorId: number;
    sectorName: string;
    sectorWeight: number;
}

export interface StockRegion {
    regionId: number;
    regionName: string;
    regionWeight: number;
}

export interface BondRegion {
    regionId: number;
    regionName: string;
    regionWeight: number;
}

export interface MaturityClass {
    maturityId: number;
    maturityName: string;
    maturityWeight: number;
}

export interface CreditQualityClass {
    creditQualityId: number;
    creditQualityName: string;
    creditQualityWeight: number;
}

export interface GetModelPortfolioResponse {
    modelPortfolioId: number;
    investmentStrategyText: string;
    referenceDateCharacteristics: string;
    basicCharacteristics: BasicCharacteristics;
    riskCharacteristics: RiskCharacteristics;
    characteristicsUnderlyingStocks?: CharacteristicsUnderlyingStocks;
    characteristicsUnderlyingBonds?: CharacteristicsUnderlyingBonds;
    referenceDateHistoricalReturn: string;
    historicalReturns: HistoricalReturnData[];
    referenceDateStockSectors: string;
    stockSectors: StockSector[];
    referenceDateBondSectors?: string;
    bondSectors?: BondSector[];
    referenceDateStockRegions: string;
    stockRegions: StockRegion[];
    referenceDateBondRegions?: string;
    bondRegions?: BondRegion[];
    referenceDateMaturity?: string;
    maturities?: MaturityClass[];
    referenceDateCreditQuality?: string;
    creditQualities?: CreditQualityClass[];
}
